<div class="map__wrapper">
  <div class="map" #map></div>
  <div class="map__content" *ngIf="location">
    <div class="box">
      <app-location [location]="location"></app-location>
    </div>
  </div>
</div>
